var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skyWeektime"},[_c('drag-weektime',{attrs:{"colspan":_vm.colspan},on:{"change":_vm.change},model:{value:(_vm.selfValue),callback:function ($$v) {_vm.selfValue=$$v},expression:"selfValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }